import { render } from "./HistoryChanges.vue?vue&type=template&id=32e4721b"
import script from "./HistoryChanges.vue?vue&type=script&lang=js"
export * from "./HistoryChanges.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__